import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { BsFillChatDotsFill } from "react-icons/bs";

function LiveChatIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading title={"Live Chat"} icon={<BsFillChatDotsFill size={50} />} />
        <IncomeCard
          title={"Total"}
          amount={props?.liveChatTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.liveChatDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.liveChatWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.liveChatMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.liveChatYearlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default LiveChatIncome;
